import { render, staticRenderFns } from "./Vip_sales.vue?vue&type=template&id=90063e72&"
import script from "./Vip_sales.vue?vue&type=script&lang=js&"
export * from "./Vip_sales.vue?vue&type=script&lang=js&"
import style0 from "./Vip_sales.vue?vue&type=style&index=0&id=90063e72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports